'use client';

import { useEffect } from 'react';

export default function HeroDecorClient() {
  useEffect(() => {
    const spans = document.querySelectorAll('.hero-text-container .text-text-white');
    spans.forEach(span => {
      span.classList.add('hero-highlight');
    });
  }, []);

  return null;
}
